import { TbTag } from "react-icons/tb";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  dateExtractFromSub,
  discountedPrice,
} from "../../../../components/stripeSubscription/utils/discountedPrice";
import {
  listOfSubscriptionNames,
  plansEnvConfig,
} from "../../../../common/envConfig";

export default function ProratedInfo({ subscriptionData, selectedPlan }) {
  const previousPlanPriceCents =
    plansEnvConfig[subscriptionData?.productId] * 100;
  const newPlanPriceCents = plansEnvConfig[selectedPlan] * 100;

  const { startDate, endDate } = dateExtractFromSub(subscriptionData);
  const remainingCreditCents = discountedPrice({
    previousSubStartDate: startDate,
    previousSubEndDate: endDate,
    planPriceCents: previousPlanPriceCents,
  });

  const proratedCents = Math.max(newPlanPriceCents - remainingCreditCents, 0);
  const proratedPrice = (proratedCents / 100).toFixed(2);

  return (
    <div className="flex flex-col gap-2">
      <div className="text-gray600 text-sm">
        Because you’re currently on{" "}
        <span className="font-bold">
          {listOfSubscriptionNames[subscriptionData?.productId]}
        </span>{" "}
        and your billing cycle ends on{" "}
        <span className="font-bold">
          {moment(Number(subscriptionData?.endDate)).format("MMMM DD, YYYY")}
        </span>
        , your new plan will be prorated. You’ll be charged{" "}
        <span className="font-bold">${proratedPrice}</span> for this change.
      </div>

      <div className="w-fit bg-pink50 rounded-2xl px-2 py-0.5 flex items-center gap-1">
        <TbTag className="size-3 min-w-3 text-pink500" />
        <div className="text-pink700 text-xs font-semibold">
          Includes credit for unused days from your current plan
        </div>
      </div>
    </div>
  );
}
